import { ReadTimesheetEntryContractorVisit } from "@/types/timesheetEntryContractorVisit";
import { normalizeDatetimeForWrite } from "@/lib/utils/normalizeDatetimeForWrite";

export const convertReadTimesheetEntryContractorVisitToFormEntry = <
  T extends ReadTimesheetEntryContractorVisit,
>(
  item: T,
): T => ({
  ...item,
  start_datetime:
    normalizeDatetimeForWrite(item.start_datetime) ?? item.start_datetime,
  end_datetime:
    normalizeDatetimeForWrite(item.end_datetime) ?? item.end_datetime,
});
